var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g({staticClass:"primary",attrs:{"input-value":_vm.active,"text":"","to":!_vm.disableNav ? _vm.route : undefined}},_vm.activator),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }